import React, { type ReactNode } from "react";
import styled from "styled-components";
import LogoSVG from "images/icons/upserve.svg";

interface LoaderIconProps {
  color?: string;
  size?: React.CSSProperties["width"];
}

const LoaderIcon = styled.div<LoaderIconProps>(
  ({
    theme,
    color = theme.components.loader.color,
    size = theme.components.loader.size,
  }) => ({
    width: size,
    height: size,
    position: "relative",
    "&:before": {
      content: '" "',
      position: "absolute",
      top: 0,
      left: 0,
      display: "block",
      width: "100%",
      height: "100%",
      background: color,
      mask: `url(${LogoSVG}) no-repeat center`,
      maskSize: "contain",
    },
    "&:after": {
      content: '" "',
      position: "absolute",
      top: 0,
      left: 0,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "100%",
      boxSizing: "border-box",
      border: `4px solid ${color}`,
      borderTopColor: `color-mix(in oklab, ${color}, black 20%)`,
      animation: "spin 1s infinite linear",
    },
  })
);

const LoaderContainer = styled.div(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  flexDirection: "column" as const,
  gap: "2em",
}));

export interface LoaderNewProps extends LoaderIconProps {
  children?: ReactNode;
  className?: string;
}

export const Loader = ({ children, className, ...rest }: LoaderNewProps) => {
  return (
    <LoaderContainer className={className} data-testid="loader">
      {children}
      <LoaderIcon {...rest} />
    </LoaderContainer>
  );
};
